import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLargeDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconChevronLargeDown"><Path fillRule="evenodd" clipRule="evenodd" d="M2.05764 9.26723C2.18625 9.02286 2.48861 8.92903 2.73297 9.05764L11.3015 13.5674C11.7388 13.7975 12.2614 13.7975 12.6987 13.5674L21.2672 9.05764C21.5116 8.92903 21.8139 9.02286 21.9426 9.26723C22.0712 9.51159 21.9773 9.81395 21.733 9.94256L13.1645 14.4523C12.4356 14.8359 11.5646 14.8359 10.8357 14.4523L2.26723 9.94256C2.02286 9.81395 1.92903 9.51159 2.05764 9.26723Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLargeDown;
